import { useState } from 'preact/hooks';

import { lightenColor } from '@/helpers/functions/theme';
import type { T_UseHoverBackgroundOptions } from '@/types/Theme';

export const useHoverBackground = ({
  baseColor,
  percent = 20,
  onEnter,
  onLeave,
}: T_UseHoverBackgroundOptions) => {
  const [isHovered, setIsHovered] = useState(false);

  return {
    backgroundColor: isHovered ? lightenColor(baseColor, percent) : baseColor,
    hoverHandlers: {
      onMouseEnter: () => {
        setIsHovered(true);
        onEnter?.();
      },
      onMouseLeave: () => {
        setIsHovered(false);
        onLeave?.();
      },
    },
    isHovered,
  };
};
